






import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
@Component
export default class ComponentProductMoreDetailsLink extends mixins(
  MixinGeneral
) {
  @Prop({ default: '', type: String }) readonly to!: string
}
